/**
 * @generated SignedSource<<bb772e1faa243013da8bf66701830a59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomEditMainGeneral_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomPropertySelect_data" | "TranslatableTextField_data">;
  readonly " $fragmentType": "RoomEditMainGeneral_data";
};
export type RoomEditMainGeneral_data$key = {
  readonly " $data"?: RoomEditMainGeneral_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomEditMainGeneral_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomEditMainGeneral_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomPropertySelect_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranslatableTextField_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1cc59acff2384e469f438c818036ed48";

export default node;
